module.exports = __webpack_public_path__ + "img/icon-mail-primary.b5afedcd.svg";